var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.questionBlock)?_c('div',{key:_vm.$route.path},[_c('QuestionBlock',{key:_vm.$route.path,attrs:{"block-data":_vm.questionBlock}})],1):_c('div',[_c('g-title',[_vm._v("Ingen Fråga!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }